import { render } from "./NewsAdd.vue?vue&type=template&id=57c78892&scoped=true"
import script from "./NewsAdd.vue?vue&type=script&lang=js"
export * from "./NewsAdd.vue?vue&type=script&lang=js"

import "./NewsAdd.vue?vue&type=style&index=0&id=57c78892&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c78892"]])

export default __exports__